import { type ProductGroupItem } from "@/app/(site)/_components/Organisms/ProductGrids/ProductGridCard"
import ProductGridModuleContent from "@/app/(site)/_components/Organisms/ProductGrids/ProductGridModuleContent"
import ProductGridSimpleContent from "@/app/(site)/_components/Organisms/ProductGrids/ProductGridSimpleContent"
import { type RowGroup } from "@/app/(site)/_components/Organisms/ProductGrids/types/grid-content"
import { type ReactNode } from "react"

export type { ProductGroupItem } from "@/app/(site)/_components/Organisms/ProductGrids/ProductGridCard"

type ProductGridContentProps = {
    products: ProductGroupItem[]
    desktopRowGroups: RowGroup<ProductGroupItem>[]
    mobileRowGroups: RowGroup<ProductGroupItem>[]
    renderedGridContent: Record<string, ReactNode>
    params: { locale: string; categories: string[] }
    listHierarchy: string
    desktopEagerCount: number
    desktopColumns: number
}

export default function ProductGridContent({
    products,
    desktopRowGroups,
    mobileRowGroups,
    renderedGridContent,
    params,
    listHierarchy,
    desktopEagerCount,
    desktopColumns
}: ProductGridContentProps) {
    const hasGridContent = desktopRowGroups.length > 0 || mobileRowGroups.length > 0

    if (!hasGridContent) {
        return (
            <ProductGridSimpleContent
                products={products}
                params={params}
                listHierarchy={listHierarchy}
                desktopEagerCount={desktopEagerCount}
            />
        )
    }

    return (
        <ProductGridModuleContent
            desktopRowGroups={desktopRowGroups}
            mobileRowGroups={mobileRowGroups}
            renderedGridContent={renderedGridContent}
            params={params}
            listHierarchy={listHierarchy}
            desktopEagerCount={desktopEagerCount}
            desktopColumns={desktopColumns}
        />
    )
}
